import { Component, inject } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RepresentativeControls } from '../edit-case-dialog.service';
import { PayeePopupComponent } from '../../../shared/payee-popup/payee-popup.component';

export type UnlockRepresentativesDialogData = {
  lock_representatives: FormControl<boolean>;
  representatives: FormArray<FormGroup<RepresentativeControls>>;
};

@Component({
  selector: 'app-unlock-representatives-dialog',
  templateUrl: './unlock-representatives-dialog.component.html',
  styleUrls: ['./unlock-representatives-dialog.component.scss'],
  imports: [PayeePopupComponent],
})
export class UnlockRepresentativesDialogComponent {
  private dialogRef =
    inject<MatDialogRef<UnlockRepresentativesDialogComponent>>(MatDialogRef);

  data = inject<UnlockRepresentativesDialogData>(MAT_DIALOG_DATA);

  readonly submit = () => {
    this.data.lock_representatives.patchValue(false);
    this.data.representatives.disable();
    this.dialogRef.close();
  };

  readonly cancel = () => {
    this.dialogRef.close();
  };
}
